import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import * as type from '../../types';
import { loginApi } from '../../api/common/authApi';
import axios from "axios"

function* fetchLoginSaga(action) {
  try {
      const data = yield call(loginApi, action.payload);
          console.log("LOGIN API RESPONSE:", data);

      yield put({ type: type.FETCH_LOGIN_SUCCESS, data });
  } catch (error) {
      yield put({
          type: type.FETCH_LOGIN_FAILURE,
          message: error.response?.data?.message || "Invalid credentials",
          status: error.response?.status || 500  // Capture the HTTP status
      });
  }
}

// function* signupSaga(action) {
//     try {
//         const res = yield call(axios.post, "https://apilead.blaccdot.com/api/auth/signup", action.payload)
//         yield put({ type: type.FETCH_SIGNUP_SUCCESS, response: res.data })
//     }
//     catch (error) {
//         yield put({ type: type.FETCH_SIGNUP_FAILURE, error })
//     }
// }
function* signupSaga(action) {
  try {
    const res = yield call(
      axios.post,
      "https://apilead.blaccdot.ae/api/auth/signup",
      action.payload
    );

    yield put({
      type: type.FETCH_SIGNUP_SUCCESS,
      response: res.data,
    });
  } catch (error) {
    yield put({
      type: type.FETCH_SIGNUP_FAILURE,
      message:
        error.response?.data?.message || "Signup failed",
      status: error.response?.status || 500,
    });
  }
}


export function* watchFetchLoginSaga() {
    yield takeEvery(type.FETCH_LOGIN, fetchLoginSaga);
    yield takeLatest(type.FETCH_SIGNUP_REQUEST, signupSaga );
}
 
// import { call, put, takeEvery } from 'redux-saga/effects'
// import * as type from '../../types';
// import { loginApi } from '../../api/common/authApi';

// function* fetchLoginSaga(action) {
//     try {
//        const data = yield call(loginApi, action.payload);
//        yield put({type: type.FETCH_LOGIN_SUCCESS, data});
//     } catch (e) {
//        yield put({type: type.FETCH_LOGIN_FAILURE, message: e.message});
//     }
// }
 


// export function* watchFetchLoginSaga() {
//     yield takeEvery(type.FETCH_LOGIN, fetchLoginSaga);
// }
 